import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
function f(e) {
	return e instanceof Date ? e.toISOString() : String(e);
}
var p = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7080/Rex";
	}
	createLead(e, t) {
		let r = this.baseUrl + "/CreateLead", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processCreateLead(e)));
	}
	processCreateLead(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	exportNetworkItemizedTransactions(e, t) {
		let r = this.baseUrl + "/ExportNetworkItemizedTransactions", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "text/csv"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processExportNetworkItemizedTransactions(e)));
	}
	processExportNetworkItemizedTransactions(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? M("Unauthorized request", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getActiveListingsForAgency(e, t) {
		let r = this.baseUrl + "/GetActiveListingsForAgency";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetActiveListingsForAgency(e)));
	}
	processGetActiveListingsForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAgencyListingsPermanentLinkModel(e, t) {
		let r = this.baseUrl + "/GetAgencyListingsPermanentLinkModel";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetAgencyListingsPermanentLinkModel(e)));
	}
	processGetAgencyListingsPermanentLinkModel(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? M("Invalid agency Id supplied", e.status, e.data, t) : e.status === 401 ? M("Unauthorized request", e.status, e.data, t) : e.status === 404 ? M("Brand account Id not found", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getContractCommissionDiscrepancies(e, t, r, i) {
		let a = this.baseUrl + "/GetContractCommissionDiscrepancies";
		if (a += "?", e === null) throw new globalThis.Error("The parameter 'periodStart' cannot be null.");
		if (e !== void 0 && (a += "periodStart=" + encodeURIComponent(f(e)) + "&"), t === null) throw new globalThis.Error("The parameter 'periodEnd' cannot be null.");
		if (t !== void 0 && (a += "periodEnd=" + encodeURIComponent(f(t)) + "&"), r === null) throw new globalThis.Error("The parameter 'filterByAnniversaryDate' cannot be null.");
		r !== void 0 && (a += "filterByAnniversaryDate=" + encodeURIComponent(f(r)) + "&"), a = a.replace(/[?&]$/, "");
		let o = {
			method: "GET",
			url: a,
			headers: { Accept: "application/json" },
			signal: i
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processGetContractCommissionDiscrepancies(e)));
	}
	processGetContractCommissionDiscrepancies(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? M("Invalid request parameters", e.status, e.data, t) : e.status === 401 ? M("Unauthorized request", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getExecutiveKeyMetrics(e, t) {
		let r = this.baseUrl + "/GetExecutiveKeyMetrics";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'month' must be defined and cannot be null.");
		r += "month=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetExecutiveKeyMetrics(e)));
	}
	processGetExecutiveKeyMetrics(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getExecutiveRunRateMetrics(e, t) {
		let r = this.baseUrl + "/GetExecutiveRunRateMetrics";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'month' must be defined and cannot be null.");
		r += "month=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetExecutiveRunRateMetrics(e)));
	}
	processGetExecutiveRunRateMetrics(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getLeaderboardStatisticsForEntity(e, t) {
		let r = this.baseUrl + "/GetLeaderboardStatisticsForEntity", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetLeaderboardStatisticsForEntity(e)));
	}
	processGetLeaderboardStatisticsForEntity(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getListingByCampaignId(e, t) {
		let r = this.baseUrl + "/GetListingByCampaignId";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetListingByCampaignId(e)));
	}
	processGetListingByCampaignId(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? M("Invalid campaign Id supplied", e.status, e.data, t) : e.status === 401 ? M("Unauthorized request", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getListingDiscrepancies(e, t, r, i) {
		let a = this.baseUrl + "/GetListingDiscrepancies";
		if (a += "?", e === null) throw new globalThis.Error("The parameter 'periodStart' cannot be null.");
		if (e !== void 0 && (a += "periodStart=" + encodeURIComponent(f(e)) + "&"), t === null) throw new globalThis.Error("The parameter 'periodEnd' cannot be null.");
		if (t !== void 0 && (a += "periodEnd=" + encodeURIComponent(f(t)) + "&"), r === null) throw new globalThis.Error("The parameter 'filterByAnniversaryDate' cannot be null.");
		r !== void 0 && (a += "filterByAnniversaryDate=" + encodeURIComponent(f(r)) + "&"), a = a.replace(/[?&]$/, "");
		let o = {
			method: "GET",
			url: a,
			headers: { Accept: "application/json" },
			signal: i
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processGetListingDiscrepancies(e)));
	}
	processGetListingDiscrepancies(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? M("Invalid request parameters", e.status, e.data, t) : e.status === 401 ? M("Unauthorized request", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getNetworkPartnershipMetrics(e, t) {
		let r = this.baseUrl + "/GetNetworkPartnershipMetrics", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetNetworkPartnershipMetrics(e)));
	}
	processGetNetworkPartnershipMetrics(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getNetworkStateMetrics(e, t) {
		let r = this.baseUrl + "/GetNetworkStateMetrics", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetNetworkStateMetrics(e)));
	}
	processGetNetworkStateMetrics(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getPartnershipInformation(e, t) {
		let r = this.baseUrl + "/GetPartnershipInformation", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetPartnershipInformation(e)));
	}
	processGetPartnershipInformation(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getPublishedListingDetail(e, t, r) {
		let i = this.baseUrl + "/GetPublishedListingDetail";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (i += "agencyId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'listingId' must be defined and cannot be null.");
		i += "listingId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetPublishedListingDetail(e)));
	}
	processGetPublishedListingDetail(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getPublishedListingDetails(e, t) {
		let r = this.baseUrl + "/GetPublishedListingDetails", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetPublishedListingDetails(e)));
	}
	processGetPublishedListingDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getPublishedListingsAgentsAndSuburbs(e, t, r, i) {
		let a = this.baseUrl + "/GetPublishedListingsAgentsAndSuburbs";
		if (a += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (a += "agencyId=" + encodeURIComponent(f(e)) + "&", t === null) throw new globalThis.Error("The parameter 'listingState' cannot be null.");
		if (t !== void 0 && (a += "listingState=" + encodeURIComponent(f(t)) + "&"), r === null) throw new globalThis.Error("The parameter 'listingCategories' cannot be null.");
		if (r !== void 0) for (let e of r) a += "listingCategories=" + encodeURIComponent(f(e)) + "&";
		a = a.replace(/[?&]$/, "");
		let o = {
			method: "GET",
			url: a,
			headers: { Accept: "application/json" },
			signal: i
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processGetPublishedListingsAgentsAndSuburbs(e)));
	}
	processGetPublishedListingsAgentsAndSuburbs(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getStatisticsForEntity(e, t) {
		let r = this.baseUrl + "/GetStatisticsForEntity", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetStatisticsForEntity(e)));
	}
	processGetStatisticsForEntity(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getSuburbs(e, t) {
		let r = this.baseUrl + "/GetSuburbs", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetSuburbs(e)));
	}
	processGetSuburbs(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getTopPerformers(e) {
		let t = this.baseUrl + "/GetTopPerformers", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetTopPerformers(e)));
	}
	processGetTopPerformers(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	rexBrandAccountWebhook(e, t, r) {
		let i = this.baseUrl + "/RexBrandAccountWebhook";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		i += "agencyId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: { "Content-Type": "application/json" },
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processRexBrandAccountWebhook(e)));
	}
	processRexBrandAccountWebhook(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 || e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	setListingPublishedToPortal(e, t) {
		let r = this.baseUrl + "/SetListingPublishedToPortal", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetListingPublishedToPortal(e)));
	}
	processSetListingPublishedToPortal(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetCurrentPartnershipInformation(e, t, r, i) {
		let a = this.baseUrl + "/StaffGetCurrentPartnershipInformation";
		if (a += "?", e === null) throw new globalThis.Error("The parameter 'agencyId' cannot be null.");
		if (e !== void 0 && (a += "agencyId=" + encodeURIComponent(f(e)) + "&"), t === null) throw new globalThis.Error("The parameter 'anniversaryDateToUse' cannot be null.");
		if (t !== void 0 && (a += "anniversaryDateToUse=" + encodeURIComponent(f(t)) + "&"), r === null) throw new globalThis.Error("The parameter 'previousYear' cannot be null.");
		r !== void 0 && (a += "previousYear=" + encodeURIComponent(f(r)) + "&"), a = a.replace(/[?&]$/, "");
		let o = {
			method: "GET",
			url: a,
			headers: { Accept: "application/json" },
			signal: i
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processStaffGetCurrentPartnershipInformation(e)));
	}
	processStaffGetCurrentPartnershipInformation(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetEntityNumbers(e, t) {
		let r = this.baseUrl + "/StaffGetEntityNumbers", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetEntityNumbers(e)));
	}
	processStaffGetEntityNumbers(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetLeaderboardStatistics(e, t, r, i, a, o) {
		let s = this.baseUrl + "/StaffGetLeaderboardStatistics";
		if (s += "?", e == null) throw new globalThis.Error("The parameter 'statisticsTimePeriod' must be defined and cannot be null.");
		if (s += "statisticsTimePeriod=" + encodeURIComponent(f(e)) + "&", t === null) throw new globalThis.Error("The parameter 'contractDateToUse' cannot be null.");
		if (t !== void 0 && (s += "contractDateToUse=" + encodeURIComponent(f(t)) + "&"), r === null) throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
		if (r !== void 0 && (s += "fromDate=" + encodeURIComponent(f(r)) + "&"), i === null) throw new globalThis.Error("The parameter 'toDateExclusive' cannot be null.");
		if (i !== void 0 && (s += "toDateExclusive=" + encodeURIComponent(f(i)) + "&"), a === null) throw new globalThis.Error("The parameter 'statisticsType' cannot be null.");
		a !== void 0 && (s += "statisticsType=" + encodeURIComponent(f(a)) + "&"), s = s.replace(/[?&]$/, "");
		let c = {
			method: "GET",
			url: s,
			headers: { Accept: "application/json" },
			signal: o
		};
		return this.transformOptions(c).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(s, e, (e) => this.processStaffGetLeaderboardStatistics(e)));
	}
	processStaffGetLeaderboardStatistics(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetRexBrandAccountAgencies(e) {
		let t = this.baseUrl + "/StaffGetRexBrandAccountAgencies", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processStaffGetRexBrandAccountAgencies(e)));
	}
	processStaffGetRexBrandAccountAgencies(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetUpcomingSettlementsForAgency(e, t) {
		let r = this.baseUrl + "/StaffGetUpcomingSettlementsForAgency";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetUpcomingSettlementsForAgency(e)));
	}
	processStaffGetUpcomingSettlementsForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffQueueFastBulkRexResync(e) {
		let t = this.baseUrl + "/StaffQueueFastBulkRexResync", r = {
			method: "POST",
			url: t,
			headers: {},
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processStaffQueueFastBulkRexResync(e)));
	}
	processStaffQueueFastBulkRexResync(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffQueueFastBulkRexResyncForBrandAccount(e, t) {
		let r = this.baseUrl + "/StaffQueueFastBulkRexResyncForBrandAccount", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffQueueFastBulkRexResyncForBrandAccount(e)));
	}
	processStaffQueueFastBulkRexResyncForBrandAccount(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffQueueFullSlowRexResync(e) {
		let t = this.baseUrl + "/StaffQueueFullSlowRexResync", r = {
			method: "POST",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processStaffQueueFullSlowRexResync(e)));
	}
	processStaffQueueFullSlowRexResync(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffQueueFullSlowRexResyncForBrandAccount(e, t) {
		let r = this.baseUrl + "/StaffQueueFullSlowRexResyncForBrandAccount", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffQueueFullSlowRexResyncForBrandAccount(e)));
	}
	processStaffQueueFullSlowRexResyncForBrandAccount(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
}, m = /* @__PURE__ */ function(e) {
	return e.Aruba = "Aruba", e.Afghanistan = "Afghanistan", e.Angola = "Angola", e.Anguilla = "Anguilla", e.AlandIslands = "AlandIslands", e.Albania = "Albania", e.Andorra = "Andorra", e.UnitedArabEmirates = "UnitedArabEmirates", e.Argentina = "Argentina", e.Armenia = "Armenia", e.AmericanSamoa = "AmericanSamoa", e.Antarctica = "Antarctica", e.FrenchSouthernTerritories = "FrenchSouthernTerritories", e.AntiguaAndBarbuda = "AntiguaAndBarbuda", e.Australia = "Australia", e.Austria = "Austria", e.Azerbaijan = "Azerbaijan", e.Burundi = "Burundi", e.Belgium = "Belgium", e.Benin = "Benin", e.BonaireSintEustatiusAndSaba = "BonaireSintEustatiusAndSaba", e.BurkinaFaso = "BurkinaFaso", e.Bangladesh = "Bangladesh", e.Bulgaria = "Bulgaria", e.Bahrain = "Bahrain", e.Bahamas = "Bahamas", e.BosniaAndHerzegovina = "BosniaAndHerzegovina", e.SaintBarthelemy = "SaintBarthelemy", e.Belarus = "Belarus", e.Belize = "Belize", e.Bermuda = "Bermuda", e.Bolivia = "Bolivia", e.Brazil = "Brazil", e.Barbados = "Barbados", e.Brunei = "Brunei", e.Bhutan = "Bhutan", e.BouvetIsland = "BouvetIsland", e.Botswana = "Botswana", e.CentralAfricanRepublic = "CentralAfricanRepublic", e.Canada = "Canada", e.CocosKeelingIslands = "CocosKeelingIslands", e.Switzerland = "Switzerland", e.Chile = "Chile", e.China = "China", e.IvoryCoast = "IvoryCoast", e.Cameroon = "Cameroon", e.DemocraticRepublicOfTheCongo = "DemocraticRepublicOfTheCongo", e.RepublicOfTheCongo = "RepublicOfTheCongo", e.CookIslands = "CookIslands", e.Colombia = "Colombia", e.Comoros = "Comoros", e.CapeVerde = "CapeVerde", e.CostaRica = "CostaRica", e.Cuba = "Cuba", e.Curacao = "Curacao", e.ChristmasIsland = "ChristmasIsland", e.CaymanIslands = "CaymanIslands", e.Cyprus = "Cyprus", e.CzechRepublic = "CzechRepublic", e.Germany = "Germany", e.Djibouti = "Djibouti", e.Dominica = "Dominica", e.Denmark = "Denmark", e.DominicanRepublic = "DominicanRepublic", e.Algeria = "Algeria", e.Ecuador = "Ecuador", e.Egypt = "Egypt", e.Eritrea = "Eritrea", e.WesternSahara = "WesternSahara", e.Spain = "Spain", e.Estonia = "Estonia", e.Ethiopia = "Ethiopia", e.Finland = "Finland", e.Fiji = "Fiji", e.FalklandIslands = "FalklandIslands", e.France = "France", e.FaroeIslands = "FaroeIslands", e.Micronesia = "Micronesia", e.Gabon = "Gabon", e.UnitedKingdom = "UnitedKingdom", e.Georgia = "Georgia", e.Guernsey = "Guernsey", e.Ghana = "Ghana", e.Gibraltar = "Gibraltar", e.Guinea = "Guinea", e.Guadeloupe = "Guadeloupe", e.Gambia = "Gambia", e.GuineaBissau = "GuineaBissau", e.EquatorialGuinea = "EquatorialGuinea", e.Greece = "Greece", e.Grenada = "Grenada", e.Greenland = "Greenland", e.Guatemala = "Guatemala", e.FrenchGuiana = "FrenchGuiana", e.Guam = "Guam", e.Guyana = "Guyana", e.HongKong = "HongKong", e.HeardIslandAndMcDonaldIslands = "HeardIslandAndMcDonaldIslands", e.Honduras = "Honduras", e.Croatia = "Croatia", e.Haiti = "Haiti", e.Hungary = "Hungary", e.Indonesia = "Indonesia", e.IsleOfMan = "IsleOfMan", e.India = "India", e.BritishIndianOceanTerritory = "BritishIndianOceanTerritory", e.Ireland = "Ireland", e.Iran = "Iran", e.Iraq = "Iraq", e.Iceland = "Iceland", e.Israel = "Israel", e.Italy = "Italy", e.Jamaica = "Jamaica", e.Jersey = "Jersey", e.Jordan = "Jordan", e.Japan = "Japan", e.Kazakhstan = "Kazakhstan", e.Kenya = "Kenya", e.Kyrgyzstan = "Kyrgyzstan", e.Cambodia = "Cambodia", e.Kiribati = "Kiribati", e.SaintKittsAndNevis = "SaintKittsAndNevis", e.SouthKorea = "SouthKorea", e.Kuwait = "Kuwait", e.Laos = "Laos", e.Lebanon = "Lebanon", e.Liberia = "Liberia", e.Libya = "Libya", e.SaintLucia = "SaintLucia", e.Liechtenstein = "Liechtenstein", e.SriLanka = "SriLanka", e.Lesotho = "Lesotho", e.Lithuania = "Lithuania", e.Luxembourg = "Luxembourg", e.Latvia = "Latvia", e.Macau = "Macau", e.SaintMartin = "SaintMartin", e.Morocco = "Morocco", e.Monaco = "Monaco", e.Moldova = "Moldova", e.Madagascar = "Madagascar", e.Maldives = "Maldives", e.Mexico = "Mexico", e.MarshallIslands = "MarshallIslands", e.NorthMacedonia = "NorthMacedonia", e.Mali = "Mali", e.Malta = "Malta", e.Myanmar = "Myanmar", e.Montenegro = "Montenegro", e.Mongolia = "Mongolia", e.NorthernMarianaIslands = "NorthernMarianaIslands", e.Mozambique = "Mozambique", e.Mauritania = "Mauritania", e.Montserrat = "Montserrat", e.Martinique = "Martinique", e.Mauritius = "Mauritius", e.Malawi = "Malawi", e.Malaysia = "Malaysia", e.Mayotte = "Mayotte", e.Namibia = "Namibia", e.NewCaledonia = "NewCaledonia", e.Niger = "Niger", e.NorfolkIsland = "NorfolkIsland", e.Nigeria = "Nigeria", e.Nicaragua = "Nicaragua", e.Niue = "Niue", e.Netherlands = "Netherlands", e.Norway = "Norway", e.Nepal = "Nepal", e.Nauru = "Nauru", e.NewZealand = "NewZealand", e.Oman = "Oman", e.Pakistan = "Pakistan", e.Panama = "Panama", e.Pitcairn = "Pitcairn", e.Peru = "Peru", e.Philippines = "Philippines", e.Palau = "Palau", e.PapuaNewGuinea = "PapuaNewGuinea", e.Poland = "Poland", e.PuertoRico = "PuertoRico", e.NorthKorea = "NorthKorea", e.Portugal = "Portugal", e.Paraguay = "Paraguay", e.Palestine = "Palestine", e.FrenchPolynesia = "FrenchPolynesia", e.Qatar = "Qatar", e.Reunion = "Reunion", e.Romania = "Romania", e.Russia = "Russia", e.Rwanda = "Rwanda", e.SaudiArabia = "SaudiArabia", e.Sudan = "Sudan", e.Senegal = "Senegal", e.Singapore = "Singapore", e.SouthGeorgiaAndTheSouthSandwichIslands = "SouthGeorgiaAndTheSouthSandwichIslands", e.SaintHelena = "SaintHelena", e.SvalbardAndJanMayen = "SvalbardAndJanMayen", e.SolomonIslands = "SolomonIslands", e.SierraLeone = "SierraLeone", e.ElSalvador = "ElSalvador", e.SanMarino = "SanMarino", e.Somalia = "Somalia", e.SaintPierreAndMiquelon = "SaintPierreAndMiquelon", e.Serbia = "Serbia", e.SouthSudan = "SouthSudan", e.SaoTomeAndPrincipe = "SaoTomeAndPrincipe", e.Suriname = "Suriname", e.Slovakia = "Slovakia", e.Slovenia = "Slovenia", e.Sweden = "Sweden", e.Swaziland = "Swaziland", e.SintMaarten = "SintMaarten", e.Seychelles = "Seychelles", e.Syria = "Syria", e.TurksAndCaicosIslands = "TurksAndCaicosIslands", e.Chad = "Chad", e.Togo = "Togo", e.Thailand = "Thailand", e.Tajikistan = "Tajikistan", e.Tokelau = "Tokelau", e.Turkmenistan = "Turkmenistan", e.EastTimor = "EastTimor", e.Tonga = "Tonga", e.TrinidadAndTobago = "TrinidadAndTobago", e.Tunisia = "Tunisia", e.Turkey = "Turkey", e.Tuvalu = "Tuvalu", e.Taiwan = "Taiwan", e.Tanzania = "Tanzania", e.Uganda = "Uganda", e.Ukraine = "Ukraine", e.UnitedStatesMinorOutlyingIslands = "UnitedStatesMinorOutlyingIslands", e.Uruguay = "Uruguay", e.UnitedStates = "UnitedStates", e.Uzbekistan = "Uzbekistan", e.VaticanCity = "VaticanCity", e.SaintVincentAndTheGrenadines = "SaintVincentAndTheGrenadines", e.Venezuela = "Venezuela", e.BritishVirginIslands = "BritishVirginIslands", e.USVirginIslands = "USVirginIslands", e.Vietnam = "Vietnam", e.Vanuatu = "Vanuatu", e.WallisAndFutuna = "WallisAndFutuna", e.Samoa = "Samoa", e.Yemen = "Yemen", e.SouthAfrica = "SouthAfrica", e.Zambia = "Zambia", e.Zimbabwe = "Zimbabwe", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.Written = "Written", e.Unconditional = "Unconditional", e.Settled = "Settled", e.ExpectedSettlement = "ExpectedSettlement", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.General = "General", e.AppraisalRequest = "AppraisalRequest", e.ListingEnquiry = "ListingEnquiry", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.Written = "Written", e.Unconditional = "Unconditional", e.Settled = "Settled", e.ExpectedSettlement = "ExpectedSettlement", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.Month = "Month", e.Quarter = "Quarter", e.Annual = "Annual", e.Previous = "Previous", e.Custom = "Custom", e.ThisPartnershipYear = "ThisPartnershipYear", e.LastPartnershipYear = "LastPartnershipYear", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.SoldDate = "SoldDate", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.WholeNumber = "WholeNumber", e.Currency = "Currency", e.Percentage = "Percentage", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.BusinessSale = "BusinessSale", e.CommercialRental = "CommercialRental", e.CommercialSale = "CommercialSale", e.CommercialSaleRental = "CommercialSaleRental", e.HolidayRental = "HolidayRental", e.LandSale = "LandSale", e.ResidentialRental = "ResidentialRental", e.ResidentialSale = "ResidentialSale", e.RuralSale = "RuralSale", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.Current = "Current", e.Sold = "Sold", e.Withdrawn = "Withdrawn", e.Leased = "Leased", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.Available = "Available", e.UnderOffer = "UnderOffer", e.Sold = "Sold", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.VirtualTour = "VirtualTour", e.VideoLink = "VideoLink", e.InteractiveFloorPlan = "InteractiveFloorPlan", e.MiniWeb = "MiniWeb", e.ExternalLink = "ExternalLink", e.Unknown = "Unknown", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.WholeNumber = "WholeNumber", e.Currency = "Currency", e.Percentage = "Percentage", e;
}({}), te = /* @__PURE__ */ function(e) {
	return e.IndividualOrTeam = "IndividualOrTeam", e.Agency = "Agency", e.Partnership = "Partnership", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.Month = "Month", e.Quarter = "Quarter", e.Annual = "Annual", e.Previous = "Previous", e.Custom = "Custom", e.ThisPartnershipYear = "ThisPartnershipYear", e.LastPartnershipYear = "LastPartnershipYear", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.IndividualOrTeam = "IndividualOrTeam", e.Agency = "Agency", e.Partnership = "Partnership", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.Month = "Month", e.Quarter = "Quarter", e.Annual = "Annual", e.Previous = "Previous", e.Custom = "Custom", e.ThisPartnershipYear = "ThisPartnershipYear", e.LastPartnershipYear = "LastPartnershipYear", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.Month = "Month", e.Quarter = "Quarter", e.Annual = "Annual", e.Previous = "Previous", e.Custom = "Custom", e.ThisPartnershipYear = "ThisPartnershipYear", e.LastPartnershipYear = "LastPartnershipYear", e;
}({}), A = /* @__PURE__ */ function(e) {
	return e.IndividualOrTeam = "IndividualOrTeam", e.Agency = "Agency", e.Partnership = "Partnership", e;
}({}), j = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isRexApiException = !0;
	static isRexApiException(e) {
		return e.isRexApiException === !0;
	}
};
function M(e, t, n, r, i) {
	throw i ?? new j(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var N = "rex";
function P(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var F = (e, t, n) => {
	let r = new p(e);
	return r.setAuthConfig(t, n), P(r);
}, I = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.rex || `${e}/rex`;
}, L = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = I(i), u = c, d = F(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		let e = F(l, a, i);
		p(e);
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, R = a({}), z = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = L(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(R.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, B = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.createLead(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		createLead: d,
		createLeadPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, V = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.exportNetworkItemizedTransactions(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		exportNetworkItemizedTransactions: d,
		exportNetworkItemizedTransactionsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, H = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(R), s;
	n[0] === e ? s = n[1] : (s = ["getActiveListingsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getActiveListingsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, U = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getActiveListingsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, W = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(R), s;
	n[0] === e ? s = n[1] : (s = ["getAgencyListingsPermanentLinkModel", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getAgencyListingsPermanentLinkModel(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, G = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getAgencyListingsPermanentLinkModel", e] });
	}, e[0] = t, e[1] = n), n;
}, K = (e, t, n, i) => {
	let a = r(17), s = i === void 0 || i, c = o(R), l;
	a[0] !== n || a[1] !== t || a[2] !== e ? (l = [
		"getContractCommissionDiscrepancies",
		e,
		t,
		n
	], a[0] = n, a[1] = t, a[2] = e, a[3] = l) : l = a[3];
	let d = l, f;
	a[4] !== c || a[5] !== n || a[6] !== t || a[7] !== e ? (f = (r) => {
		let { signal: i } = r;
		return c.getContractCommissionDiscrepancies(e, t, n, i);
	}, a[4] = c, a[5] = n, a[6] = t, a[7] = e, a[8] = f) : f = a[8];
	let p = s && !!c, m;
	a[9] !== d || a[10] !== f || a[11] !== p ? (m = {
		queryKey: d,
		queryFn: f,
		enabled: p
	}, a[9] = d, a[10] = f, a[11] = p, a[12] = m) : m = a[12];
	let { data: h, isPending: g, isError: _ } = u(m), v;
	return a[13] !== h || a[14] !== _ || a[15] !== g ? (v = {
		data: h,
		isPending: g,
		isError: _
	}, a[13] = h, a[14] = _, a[15] = g, a[16] = v) : v = a[16], v;
}, q = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r) => {
		await t.invalidateQueries({ queryKey: [
			"getContractCommissionDiscrepancies",
			e,
			n,
			r
		] });
	}, e[0] = t, e[1] = n), n;
}, J = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(R), s;
	n[0] === e ? s = n[1] : (s = ["getExecutiveKeyMetrics", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getExecutiveKeyMetrics(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Y = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getExecutiveKeyMetrics", e] });
	}, e[0] = t, e[1] = n), n;
}, X = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(R), s;
	n[0] === e ? s = n[1] : (s = ["getExecutiveRunRateMetrics", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getExecutiveRunRateMetrics(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Z = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getExecutiveRunRateMetrics", e] });
	}, e[0] = t, e[1] = n), n;
}, Q = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getLeaderboardStatisticsForEntity(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getLeaderboardStatisticsForEntity: d,
		getLeaderboardStatisticsForEntityPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ne = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(R), s;
	n[0] === e ? s = n[1] : (s = ["getListingByCampaignId", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getListingByCampaignId(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, re = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getListingByCampaignId", e] });
	}, e[0] = t, e[1] = n), n;
}, ie = (e, t, n, i) => {
	let a = r(17), s = i === void 0 || i, c = o(R), l;
	a[0] !== n || a[1] !== t || a[2] !== e ? (l = [
		"getListingDiscrepancies",
		e,
		t,
		n
	], a[0] = n, a[1] = t, a[2] = e, a[3] = l) : l = a[3];
	let d = l, f;
	a[4] !== c || a[5] !== n || a[6] !== t || a[7] !== e ? (f = (r) => {
		let { signal: i } = r;
		return c.getListingDiscrepancies(e, t, n, i);
	}, a[4] = c, a[5] = n, a[6] = t, a[7] = e, a[8] = f) : f = a[8];
	let p = s && !!c, m;
	a[9] !== d || a[10] !== f || a[11] !== p ? (m = {
		queryKey: d,
		queryFn: f,
		enabled: p
	}, a[9] = d, a[10] = f, a[11] = p, a[12] = m) : m = a[12];
	let { data: h, isPending: g, isError: _ } = u(m), v;
	return a[13] !== h || a[14] !== _ || a[15] !== g ? (v = {
		data: h,
		isPending: g,
		isError: _
	}, a[13] = h, a[14] = _, a[15] = g, a[16] = v) : v = a[16], v;
}, ae = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r) => {
		await t.invalidateQueries({ queryKey: [
			"getListingDiscrepancies",
			e,
			n,
			r
		] });
	}, e[0] = t, e[1] = n), n;
}, oe = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getNetworkPartnershipMetrics(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getNetworkPartnershipMetrics: d,
		getNetworkPartnershipMetricsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, se = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getNetworkStateMetrics(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getNetworkStateMetrics: d,
		getNetworkStateMetricsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ce = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getPartnershipInformation(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getPartnershipInformation: d,
		getPartnershipInformationPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, le = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(R), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getPublishedListingDetail",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getPublishedListingDetail(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, ue = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getPublishedListingDetail",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, de = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getPublishedListingDetails(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getPublishedListingDetails: d,
		getPublishedListingDetailsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, fe = (e, t, n, i) => {
	let a = r(17), s = i === void 0 || i, c = o(R), l;
	a[0] !== e || a[1] !== n || a[2] !== t ? (l = [
		"getPublishedListingsAgentsAndSuburbs",
		e,
		t,
		n
	], a[0] = e, a[1] = n, a[2] = t, a[3] = l) : l = a[3];
	let d = l, f;
	a[4] !== e || a[5] !== c || a[6] !== n || a[7] !== t ? (f = (r) => {
		let { signal: i } = r;
		return c.getPublishedListingsAgentsAndSuburbs(e, t, n, i);
	}, a[4] = e, a[5] = c, a[6] = n, a[7] = t, a[8] = f) : f = a[8];
	let p = s && !!c, m;
	a[9] !== d || a[10] !== f || a[11] !== p ? (m = {
		queryKey: d,
		queryFn: f,
		enabled: p
	}, a[9] = d, a[10] = f, a[11] = p, a[12] = m) : m = a[12];
	let { data: h, isPending: g, isError: _ } = u(m), v;
	return a[13] !== h || a[14] !== _ || a[15] !== g ? (v = {
		data: h,
		isPending: g,
		isError: _
	}, a[13] = h, a[14] = _, a[15] = g, a[16] = v) : v = a[16], v;
}, pe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r) => {
		await t.invalidateQueries({ queryKey: [
			"getPublishedListingsAgentsAndSuburbs",
			e,
			n,
			r
		] });
	}, e[0] = t, e[1] = n), n;
}, me = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getStatisticsForEntity(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getStatisticsForEntity: d,
		getStatisticsForEntityPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, he = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getSuburbs(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getSuburbs: d,
		getSuburbsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ge = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(R), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getTopPerformers"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getTopPerformers(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, _e = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getTopPerformers"] });
	}, e[0] = t, e[1] = n), n;
}, ve = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { agencyId: t, body: n } = e;
		return s.rexBrandAccountWebhook(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		rexBrandAccountWebhook: d,
		rexBrandAccountWebhookPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ye = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.setListingPublishedToPortal(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		setListingPublishedToPortal: d,
		setListingPublishedToPortalPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, be = (e, t, n, i) => {
	let a = r(17), s = i === void 0 || i, c = o(R), l;
	a[0] !== e || a[1] !== t || a[2] !== n ? (l = [
		"staffGetCurrentPartnershipInformation",
		e,
		t,
		n
	], a[0] = e, a[1] = t, a[2] = n, a[3] = l) : l = a[3];
	let d = l, f;
	a[4] !== e || a[5] !== t || a[6] !== c || a[7] !== n ? (f = (r) => {
		let { signal: i } = r;
		return c.staffGetCurrentPartnershipInformation(e, t, n, i);
	}, a[4] = e, a[5] = t, a[6] = c, a[7] = n, a[8] = f) : f = a[8];
	let p = s && !!c, m;
	a[9] !== d || a[10] !== f || a[11] !== p ? (m = {
		queryKey: d,
		queryFn: f,
		enabled: p
	}, a[9] = d, a[10] = f, a[11] = p, a[12] = m) : m = a[12];
	let { data: h, isPending: g, isError: _ } = u(m), v;
	return a[13] !== h || a[14] !== _ || a[15] !== g ? (v = {
		data: h,
		isPending: g,
		isError: _
	}, a[13] = h, a[14] = _, a[15] = g, a[16] = v) : v = a[16], v;
}, $ = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetCurrentPartnershipInformation",
			e,
			n,
			r
		] });
	}, e[0] = t, e[1] = n), n;
}, xe = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffGetEntityNumbers(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffGetEntityNumbers: d,
		staffGetEntityNumbersPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Se = (e, t, n, i, a, s) => {
	let c = r(21), l = s === void 0 || s, d = o(R), f;
	c[0] !== t || c[1] !== n || c[2] !== e || c[3] !== a || c[4] !== i ? (f = [
		"staffGetLeaderboardStatistics",
		e,
		t,
		n,
		i,
		a
	], c[0] = t, c[1] = n, c[2] = e, c[3] = a, c[4] = i, c[5] = f) : f = c[5];
	let p = f, m;
	c[6] !== d || c[7] !== t || c[8] !== n || c[9] !== e || c[10] !== a || c[11] !== i ? (m = (r) => {
		let { signal: o } = r;
		return d.staffGetLeaderboardStatistics(e, t, n, i, a, o);
	}, c[6] = d, c[7] = t, c[8] = n, c[9] = e, c[10] = a, c[11] = i, c[12] = m) : m = c[12];
	let h = l && !!d, g;
	c[13] !== p || c[14] !== m || c[15] !== h ? (g = {
		queryKey: p,
		queryFn: m,
		enabled: h
	}, c[13] = p, c[14] = m, c[15] = h, c[16] = g) : g = c[16];
	let { data: _, isPending: v, isError: y } = u(g), b;
	return c[17] !== _ || c[18] !== y || c[19] !== v ? (b = {
		data: _,
		isPending: v,
		isError: y
	}, c[17] = _, c[18] = y, c[19] = v, c[20] = b) : b = c[20], b;
}, Ce = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i, a) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetLeaderboardStatistics",
			e,
			n,
			r,
			i,
			a
		] });
	}, e[0] = t, e[1] = n), n;
}, we = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(R), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["staffGetRexBrandAccountAgencies"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.staffGetRexBrandAccountAgencies(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Te = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["staffGetRexBrandAccountAgencies"] });
	}, e[0] = t, e[1] = n), n;
}, Ee = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(R), s;
	n[0] === e ? s = n[1] : (s = ["staffGetUpcomingSettlementsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetUpcomingSettlementsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, De = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetUpcomingSettlementsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, Oe = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async () => s.staffQueueFastBulkRexResync(), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffQueueFastBulkRexResync: d,
		staffQueueFastBulkRexResyncPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ke = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffQueueFastBulkRexResyncForBrandAccount(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffQueueFastBulkRexResyncForBrandAccount: d,
		staffQueueFastBulkRexResyncForBrandAccountPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Ae = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async () => s.staffQueueFullSlowRexResync(), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffQueueFullSlowRexResync: d,
		staffQueueFullSlowRexResyncPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, je = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffQueueFullSlowRexResyncForBrandAccount(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffQueueFullSlowRexResyncForBrandAccount: d,
		staffQueueFullSlowRexResyncForBrandAccountPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
};
//#endregion
export { m as AustralianPhoneNumberCallingCodeCountry, h as ContractDateToUse, g as CreateLeadRequestEnquiryType, _ as ExecutiveMetricsResponseContractType, v as GetMetricsRequestTimePeriod, y as GetPublishedListingsDetailsRequestSortingType, b as KeyMetricMetricType, x as ListingCategories, S as ListingState, C as PartnershipInformationPartnershipLevel, w as PublishedListingModelOverridenListingStatus, R as RexApiContext, j as RexApiException, z as RexApiProvider, p as RexClient, T as RexLinkLinkType, N as RexRoute, ee as RunRateMetricMetricType, te as StaffGetEntityNumbersRequestEntityType, E as StaffGetEntityNumbersRequestTimePeriod, D as StatisticsForEntityRequestEntityType, O as StatisticsForEntityRequestTimePeriod, k as StatisticsTimePeriod, A as StatisticsType, B as useCreateLead, V as useExportNetworkItemizedTransactions, H as useGetActiveListingsForAgency, W as useGetAgencyListingsPermanentLinkModel, K as useGetContractCommissionDiscrepancies, J as useGetExecutiveKeyMetrics, X as useGetExecutiveRunRateMetrics, Q as useGetLeaderboardStatisticsForEntity, ne as useGetListingByCampaignId, ie as useGetListingDiscrepancies, oe as useGetNetworkPartnershipMetrics, se as useGetNetworkStateMetrics, ce as useGetPartnershipInformation, le as useGetPublishedListingDetail, de as useGetPublishedListingDetails, fe as useGetPublishedListingsAgentsAndSuburbs, me as useGetStatisticsForEntity, he as useGetSuburbs, ge as useGetTopPerformers, U as useInvalidateUseGetActiveListingsForAgency, G as useInvalidateUseGetAgencyListingsPermanentLinkModel, q as useInvalidateUseGetContractCommissionDiscrepancies, Y as useInvalidateUseGetExecutiveKeyMetrics, Z as useInvalidateUseGetExecutiveRunRateMetrics, re as useInvalidateUseGetListingByCampaignId, ae as useInvalidateUseGetListingDiscrepancies, ue as useInvalidateUseGetPublishedListingDetail, pe as useInvalidateUseGetPublishedListingsAgentsAndSuburbs, _e as useInvalidateUseGetTopPerformers, $ as useInvalidateUseStaffGetCurrentPartnershipInformation, Ce as useInvalidateUseStaffGetLeaderboardStatistics, Te as useInvalidateUseStaffGetRexBrandAccountAgencies, De as useInvalidateUseStaffGetUpcomingSettlementsForAgency, ve as useRexBrandAccountWebhook, L as useRexClientContext, ye as useSetListingPublishedToPortal, be as useStaffGetCurrentPartnershipInformation, xe as useStaffGetEntityNumbers, Se as useStaffGetLeaderboardStatistics, we as useStaffGetRexBrandAccountAgencies, Ee as useStaffGetUpcomingSettlementsForAgency, Oe as useStaffQueueFastBulkRexResync, ke as useStaffQueueFastBulkRexResyncForBrandAccount, Ae as useStaffQueueFullSlowRexResync, je as useStaffQueueFullSlowRexResyncForBrandAccount };
